module.exports = __webpack_public_path__ + "img/acid_picdump_42.f45595ab.jpg";